module.exports = __webpack_public_path__ + "img/chofu_cycle_on.1f50a8a5.svg";